import { DownloadImages } from '../vendors/ngab/load/CacheImages';

// количество попыток запроса непрогруженных картинок
const ATTEMPTSCOUNT = 5;

const SureDownloadImages = async (...data) => {
    // номер попытки
    let attempt = 0;

    const loadImages = async () => {
        attempt += 1;
        let images;

        try {
            images = await DownloadImages(...data);

            const imagesWithError = Object.entries(images).filter(([, value]) => value.error);

            if (imagesWithError.length && attempt < ATTEMPTSCOUNT) {
                await loadImages();
            } else if (imagesWithError.length) {
                console.log('not loaded images:');
                console.log(imagesWithError.map(([, i]) => i.id));
            }

        } catch (err) {
            console.log(err);
        }

        return images || {};
    };

    const resultImages = await loadImages();

    return resultImages;
};

const CacheImages = async (srcArray, doThat, progressUpdate = false) => {
    if (!doThat) {
        // resolve(doThat);

        return;
    }

    const notLoadedImages = [];

    let progressValue = 0;
    const delta = 100 / srcArray.length;
    const images = srcArray.map(() => new Image());
    const promiseArray = images.map((image, index) => new Promise((resolve) => {
        const handler = () => {
            progressValue += delta;
            if (typeof progressUpdate === 'function') progressUpdate.call(this, progressValue);
            resolve();
        };

        image.onload = handler;
        image.onerror = () => {
            notLoadedImages.push(image.src);
            resolve();
        };

        image.src = srcArray[index];
    }));

    await Promise.all(promiseArray);
    // eslint-disable-next-line
    return notLoadedImages;
};

const SureCacheImages = async (...data) => {
    let attempt = 0;

    const loadImages = async () => {
        attempt += 1;
        const notLoadedImages = await CacheImages(...data);

        if (notLoadedImages.length && attempt < ATTEMPTSCOUNT) {
            await loadImages();
        } else if (notLoadedImages.length) {
            console.log('images has not loaded:');
            console.log(notLoadedImages);
        }
    };

    await loadImages();
};

export { SureDownloadImages, SureCacheImages };
